import React from 'react';
import {
  Grid,
} from '@mairistem/composants';
import { TiersAdresseList, TiersContact } from '@mairistem/comptabilite';
import Contact from '@mairistem/comptabilite/lib/ts/src/interfaces/tiers/contact';
import { Adresse } from '@mairistem/comptabilite/lib/ts/src/interfaces/tiers/adresse';

interface TiersFichePanelAdressesContactsProps {
  onChange: (e: any) => void;
  contacts?: Contact[];
  adresses?: Adresse[];
  deletedAdresses?: number[];
  deletedContacts?: number[];
  identifiant?: number | string;
}

const TiersFichePanelAdressesContacts = ({
  onChange,
  contacts,
  adresses,
  deletedAdresses,
  deletedContacts,
  identifiant,
}: TiersFichePanelAdressesContactsProps) => (
  <Grid>
    <Grid.Row columns={2}>
      <Grid.Column>
        <TiersAdresseList identifiant={identifiant} adresses={adresses} onChange={onChange} deletedAdresses={deletedAdresses} />
      </Grid.Column>
      <Grid.Column>
        <TiersContact onChange={onChange} contacts={contacts} deletedContacts={deletedContacts} identifiant={identifiant} />
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

export default TiersFichePanelAdressesContacts;
